export const projects = [
	{
		path: "adrianaspage",
		title: "Adrianas Insurance Webpage",
		description:
			"Recreation from scratch of the Adriana's Insurance Webpage, now made in NextJs. The page is made with both english and spanish translations along with being mobile friendly.",
		url: "",
		imgAmount: 7,
		tags: ["React", "Next.js", "TailwindCSS", "PostgreSQL", "Sequelize"],
	},
	{
		path: "aquoter",
		title: "Online Car Insurance Quoter",
		description:
			"A React single page application for making quotes. Responsive design, allows for multiple drivers and cars, uses an API for connecting to an insurance quoter to get the price.",
		url: "",
		imgAmount: 3,
		tags: ["React", "CSS", "External APIs"],
	},
	{
		path: "uw22",
		title: "Web Application for Managing Agents",
		description:
			"Made with Node.js and Express/Pug. Allows for creating offices and users with different permissions, along with creating and assigning notices of wrong sales. You can edit these sales, their errors, and mark them as solved.",
		url: "",
		imgAmount: 2,
		tags: ["Node.Js", "Express", "Javascript", "PostgreSQL", "Sequelize"],
	},
	{
		path: "webquotes",
		title: "Web Application for Managing Quotes",
		description:
			"Made with Next.Js. It allows for users to view quotes/leads from forms that users have submitted. Users can have different permissions and regions, and updates automatically with sockets using an API. Allows for assigning and editing quotes in the same page.",
		url: "",
		imgAmount: 3,
		tags: ["React", "Next.js", "TailwindCSS", "PostgreSQL", "Sequelize"],
	},
];
